import App from './App.vue'
import Vue from 'vue'
import i18n from './i18n'
import router from './router'
import store from './store'

import './event-bus'

import './ui-components'

import './plugins'
import './mixins'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
